export enum UtishaTheme {
  TEACHER = 'teacher', STUDENT = 'student'
}
